import { db } from "../../Environment/firebase";
import firebase from "firebase/compat/app";
import { WhereFilterOp } from "firebase/firestore";

export async function getDatabaseData(collection: string, field: string, query: WhereFilterOp, condition: string) {
    //collection: 検索するコレクションの名前
    //field: 検索対象
    //query: 検索クエリ in,==,!= など
    //condition: 検索条件
    //limit: 取得データ上限
    const data: { id: string, value: firebase.firestore.DocumentData }[] = []

    await db.collection(collection)
        .where(field, query, condition)
        .get()
        .then((querySnapshot) => {
            if (querySnapshot.docs.length == 0) {
                console.log('データは0件です')
            } else {
                querySnapshot.forEach((doc) => {
                    const docs = {
                        id: doc.id,
                        value: doc.data()
                    }
                    data.push(docs);
                });
            }
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });

    return data
}

export async function setDatabaseData(
    collection: string,
    collectionId: string,
    data: {},
): Promise<void> {
    await db.collection(collection)
        .doc(collectionId)
        .set(data, { merge: true })
        .then(() => {
            console.log("Document successfully written!");
        })
        .catch((err) => {
            console.log("error:", err);
        });
}


async function setSubcollection(
    collection: string,
    collectionId: string,
    subcollection: string,
    subcollectionId: string,
    data: {},
): Promise<void> {
    await db.collection(collection)
        .doc(collectionId)
        .collection(subcollection)
        .doc(subcollectionId)
        .set(data, { merge: true })
        .then(() => {
            console.log("Document successfully written!");
        })
        .catch((err) => {
            console.log("error:", err);
        });
}

async function deleteSubcollection(
    collection: string,
    collectionId: string,
    subcollection: string,
    subcollectionId: string,
): Promise<void> {
    await db.collection(collection)
        .doc(collectionId)
        .collection(subcollection)
        .doc(subcollectionId)
        .delete()
        .then(() => {
            console.log("Document successfully deleted!");
        })
        .catch((err) => {
            console.log("error:", err);
        });
}


export async function handleUsersAndDwh(userDataId: string, dwhId: string, subcollection: string, state: boolean, dataContents: {}): Promise<void> {
    if (!state) {
        try {
            await setSubcollection('dwh', dwhId, subcollection, userDataId, dataContents)
            await setSubcollection('users', userDataId, subcollection, dwhId, dataContents);
        } catch (error) {
            console.error('Error:', error);
        }
    } else {
        try {
            await deleteSubcollection('dwh', dwhId, subcollection, userDataId)
            await deleteSubcollection('users', userDataId, subcollection, dwhId)
        } catch (error) {
            console.error('Error:', error)
        }
    }
};